// component
import CustomerList from "../components/customer-list/CustomerList";
import CustomButton from "../components/kits/button/CustomButton";
import ModalFilter from "../components/customer-list/ModalFIlter";
import CustomerInfoModal from "../components/customer-list/CustomerInfoModal.jsx";
import AddEditCustomerModal from "../components/customer-list/customerModal/AddEditCustomerModal";
import Loader from "../utils/Loader";
import { searchFunc } from "../utils/helperFunction";
import SearchInputContext from "../Search/SearchInput";
// react
import { useState, useEffect, useContext } from "react";

import useAxios from "../services/useAxios";
import { translateToReactSelect } from "../utils/helperFunction";
import Helmet from "react-helmet";
import AuthenticationContext from "../Authentication/AuthenticationContext.ts";

export default function CustomersList() {
  const { userInfo } = useContext(AuthenticationContext);

  const [show, setShow] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [customerInfoShow, setCustomerInfoShow] = useState(false);
  const [tagOption, setTagOption] = useState([]);
  const [userOption, setUserOption] = useState([]);
  const [bankName, setBankName] = useState([]);
  const [content, setContent] = useState([]);
  const [customerUpdater, setCustomerUpdater] = useState(false);
  const [tagUpdater, setTagUpdater] = useState(false);

  const { execute: getHashtag } = useAxios("api/Find_tag");
  const { loadingUser, execute: findUser } = useAxios("api/Find_users");
  const { loadingConfig, execute: getConfig } = useAxios("api2/get_configs");
  const { execute: getCustomer } = useAxios("api2/get_customers");
  const [loading, setLoading] = useState(true);

  const [baseContent, setBaseContent] = useState([]);
  const { searchInput } = useContext(SearchInputContext);

  useEffect(() => {
    findUser().then((result) => {
      setUserOption(translateToReactSelect(false, result, "fullname", true));
    });
    getConfig().then((result) => {
      setBankName(result.banks);
      async function loadpage() {
        await getCustomer().then((data) => {
          setContent(data.customers.reverse());
          setBaseContent(data.customers.reverse());

          setLoading(false);
        });
      }
      loadpage();
    });
  }, [customerUpdater]);

  useEffect(() => {
    let temp = searchFunc(
      searchInput,
      baseContent.map((val) => {
        return {
          ...val,
          mainUid: `${val.main_uid.fullname} ${val.mobile}`,
        };
      })
    );
    setContent(temp);
  }, [searchInput]);

  useEffect(() => {
    getHashtag().then((result) => {
      setTagOption(translateToReactSelect(false, result, "text"));
      console.log("###", result);
      console.log(
        "translateToReactSelect",
        translateToReactSelect(false, result, "text")
      );
    });
  }, [tagUpdater]);

  return (
    <>
      <Helmet>
        <title>لیست مشتریان</title>
      </Helmet>
      <div className="p-customerlist">
        {loading ? <Loader /> : ""}
        <ModalFilter
          show={show}
          setShow={setShow}
          tagOption={tagOption}
          content={content}
          setContent={setContent}
          customerUpdater={customerUpdater}
          setCustomerUpdater={setCustomerUpdater}
        ></ModalFilter>
        <div className="d-flex mt-4 mx-5">
          {userInfo.userRoll.includes(5) && (
            <>
              <CustomButton
                color="success"
                size="large"
                state="normal"
                circle={false}
                onClick={() => {
                  setShowCustomerModal(true);
                }}
              >
                افزودن مشتری
              </CustomButton>
              <div>
                <AddEditCustomerModal
                  type="add"
                  headerText="افزودن مشتری"
                  show={showCustomerModal}
                  setShow={setShowCustomerModal}
                  tagOption={tagOption}
                  userOption={userOption}
                  bankName={bankName}
                  setCustomerUpdater={setCustomerUpdater}
                  setTagUpdater={setTagUpdater}
                />
              </div>
            </>
          )}
          {userInfo.userRoll.includes(4) && (
            <div className="d-flex mx-2">
              <CustomButton
                onClick={(e) => {
                  setShow(true);
                }}
                color="red"
                size="large"
                type="outline"
                state="normal"
                circle={false}
              >
                فیلتر
              </CustomButton>
            </div>
          )}
        </div>
        {userInfo.userRoll.includes(4) && (
          <CustomerList
            tagOption={tagOption}
            userOption={userOption}
            bankName={bankName}
            content={content}
            setContent={setContent}
            customerUpdater={customerUpdater}
            setCustomerUpdater={setCustomerUpdater}
            loading={loading}
            setLoading={setLoading}
            tagUpdater={tagUpdater}
            setTagUpdater={setTagUpdater}
          ></CustomerList>
        )}
      </div>
    </>
  );
}
